import "./ExcelTables.css";

export default function ExcelRowPreview({ rows = [] }) {
  if (!rows.length) return null;

  return (
    <section className="excel-table-card">
      <div className="excel-table-card__header">
        <h3>Rij preview</h3>
        <p>Eerste rijen uit het Excel-bestand.</p>
      </div>

      <div className="excel-table-card__wrapper">
        <table>
          <thead>
            <tr>
              <th>Rij</th>
              <th>Voornaam</th>
              <th>Achternaam</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row, index) => (
              <tr key={row.row || index}>
                <td>{row.row || row.row_number || index + 1}</td>
                <td>{row.first_name || "-"}</td>
                <td>{row.last_name || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
